/* eslint-disable react/display-name */
import React, { useRef, useImperativeHandle, forwardRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

interface RecaptchaProps {
  siteKey: string;
  onVerify: (token: string | null) => void;
  className?: string;
  style?: React.CSSProperties;
}

export interface RecaptchaRef {
  reset: () => void;
}

const Recaptcha = forwardRef<RecaptchaRef, RecaptchaProps>(
  ({ siteKey, onVerify, className, style }, ref) => {
    const recaptchaRef = useRef<ReCAPTCHA>(null);

    // Exposing reset() method to parent
    useImperativeHandle(ref, () => ({
      reset: () => {
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
      },
    }));

    return (
      <div className={className} style={style}>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={siteKey || process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}
          onChange={onVerify}
        />
      </div>
    );
  }
);

export default Recaptcha;
